/*
 * @Date: 2021-11-23 11:48:00
 * @LastEditTime: 2025-07-15 12:30:05
 */
import React, { useEffect } from 'react'
import { decode } from 'js-base64'
import { HttpServer } from '../../../../services/server'
import './index.css'
import { getJsonFromUrl, globalWKLink } from '../../../../utils/tools'
import { initQiankun } from '../../../../qiankun'
import { appBaseUrl } from '@/config'

export const YkCmp = () => {
  useEffect(() => {
    init()
    return () => {
      //
      console.log((window as any)._microApp.unmount())
    }
  }, [])

  const init = () => {
    try {
      // const isDom = sessionStorage.getItem('doc_yk_cmp_container')
      // console.log(isDom)
      // if (isDom && isDom !== undefined) {
      //   return (document.getElementById('yk_cmp_container').innerHTML = sessionStorage.getItem('doc_yk_cmp_container'))
      // }
      const query: any = getJsonFromUrl()
      if (query.SKIN_TEMP_PREVIEWURL) {
        queryParams({ path: decode(query.SKIN_TEMP_PREVIEWURL) })
          .then(initQiankun)
          .catch(console.error)
        // console.log(decode(query.SKIN_TEMP_PREVIEWURL))
      } else {
        let path: string
        // TODO:这种方式是比较不合理的，讲道理应该放到配置或者后端接口返回。
        // 目前上新的活动，需有由前端替换url并且上线，后面考虑从客户端配置，针对模版只允许绑定一个活动。
        if (/(dbg.lizhiweike|localhost)/.test(location.origin)) {
          // 测试环境
          path = `${globalWKLink.wk}/yk_cmp/weikeIndexPage-708`
        } else {
          // 正式环境
          path = `${appBaseUrl}/yk_cmp/weikeIndexPage-105`
        }
        queryParams({ path }).then(initQiankun).catch(console.error)
      }

      // setTimeout(() => {
      //   sessionStorage.setItem('doc_yk_cmp_container', document.getElementById('yk_cmp_container').innerHTML)
      //   console.log(sessionStorage.getItem('doc_yk_cmp_container'))
      // }, 1000)
    } catch (error) {
      console.log(error)
    }
  }

  return <div id="yk_cmp_container" />
}

/** 携带参数处理,获取活动数据 */
export const queryParams = async ({ id, path, info }: { id?: string; path?: string; info?: any }) => {
  try {
    const regexp = str => str.substr(location.pathname.lastIndexOf('/') + 1).replace(/.*-/gi, '')
    const pathStr = path.split('?')[0]

    id = id || regexp(pathStr || location.pathname)
    /** 获取query参数 */
    const query: any = getJsonFromUrl(path)
    let paramsReq: any
    if (!query.preview) {
      paramsReq = { activity_id: id }
    } else {
      paramsReq = { ...query }
    }
    if (query && query.version_detail_id) {
      info = (await HttpServer.QiankunServer.preview({ version_detail_id: query.version_detail_id, ...paramsReq })).data.data
    } else {
      info = (await HttpServer.QiankunServer.getActivityInfo(paramsReq)).data.data
    }
    // console.log('info:', info)
    return info
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/QianKun/yk_cmp.tsx